import React, { useMemo, useState } from "react";

import { Badge, Button, SaleRecordTable } from "../ui";
import SaleAddPartModal from "./SaleAddPartModal";
import SaleEditPartModal from "./SaleEditPartModal";

const SalePartsSection = ({
    editForm,
    partsList,
    updating,
    onAddClick,
    addFormOpen,
    onCloseAddForm,
    partsItem,
    onPartsFieldChange,
    onSubmitAdd,
    addingPartsItemError,
    onSavePart,
    onRemove,
    onFieldBlur,
}) => {
    const [selectedPartIndex, setSelectedPartIndex] = useState(null);
    const [editPartModalOpen, setEditPartModalOpen] = useState(false);

    const selectedPart = useMemo(() => {
        if (selectedPartIndex === null || !partsList[selectedPartIndex]) return null;
        return partsList[selectedPartIndex];
    }, [partsList, selectedPartIndex]);

    const openPartModal = (index) => {
        setSelectedPartIndex(index);
        setEditPartModalOpen(true);
    };

    const closePartModal = () => {
        setEditPartModalOpen(false);
        setSelectedPartIndex(null);
    };

    const partColumns = [
        {
            id: "dateOrdered",
            header: "Order Date",
            width: "11%",
            cell: (item) => item.dateOrdered || "—",
        },
        {
            id: "supplier",
            header: "Supplier",
            cell: (item) => item.supplier || "—",
        },
        {
            id: "item",
            header: "Item",
            cell: (item) => item.item || "—",
        },
        {
            id: "quantity",
            header: "Qty",
            width: "8%",
            cell: (item) => item.quantity || "—",
        },
        {
            id: "note",
            header: "Note",
            cell: (item) => item.note || "—",
        },
        {
            id: "status",
            header: "Status",
            width: "12%",
            cell: (item) => (
                <Badge tone={item.itemReceived ? "success" : "warning"}>
                    {item.itemReceived ? "Received" : "Ordered"}
                </Badge>
            ),
        },
        {
            id: "edit",
            header: "",
            cell: (item, index) => (
                <button
                    type="button"
                    className="close"
                    aria-label="Edit row"
                    onClick={(e) => {
                        e.stopPropagation();
                        openPartModal(index);
                    }}
                >
                    <i className="fas fa-pen" aria-hidden="true" />
                </button>
            ),
        },
    ];

    return (
        <section className="Sale-detail-block Sale-parts-section">
            <div className="Sale-card-header">
                <h5 className="detail-section-title">Parts ({partsList.length})</h5>
                <Button
                    variant="secondary"
                    size="sm"
                    className="Sale-parts-add-btn"
                    onClick={onAddClick}
                >
                    {updating ? "Saving..." : "Add"}
                </Button>
            </div>

            <div className="Sale-top-right-ra-section">
                {partsList && partsList.length > 0 ? (
                    <SaleRecordTable
                        columns={partColumns}
                        rows={partsList}
                        getRowKey={(item, index) => `${item.item || "part"}-${index}`}
                        wrapClassName="Sale-paintform-items"
                        onRowClick={(item, index) => openPartModal(index)}
                    />
                ) : (
                    <div className="Sale-empty-state">No parts added yet.</div>
                )}
            </div>

            <SaleAddPartModal
                open={addFormOpen}
                onClose={onCloseAddForm}
                onSubmit={onSubmitAdd}
                partsItem={partsItem}
                onPartsFieldChange={onPartsFieldChange}
                addingPartsItemError={addingPartsItemError}
            />
            <SaleEditPartModal
                open={editPartModalOpen}
                onClose={closePartModal}
                editForm={editForm}
                part={selectedPart}
                partIndex={selectedPartIndex}
                onSavePart={onSavePart}
                onRemove={(index) => {
                    onRemove(index);
                    closePartModal();
                }}
                onFieldBlur={onFieldBlur}
            />
        </section>
    );
};

export default SalePartsSection;
